import React, { useEffect } from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Navigation from './components/Navigation';
import Hero from './components/Hero/Hero';
import CategoryList from './components/Categories/CategoryList';
import ProductList from './components/ProductList';
import About from './components/About/About';
import Footer from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Add this line to import Bootstrap JS
import { CartProvider } from './components/Cart/CartContext';
import Cart from './components/Cart/Cart';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Checkout from './components/Checkout/Checkout';
import ProductDetail from './components/Products/ProductDetail';
import HeroEnd from './components/Hero/HeroEnd';
// import News from './components/News/News';

// ScrollToHashElement component to handle hash navigation
const ScrollToHashElement = () => {
  const location = useLocation();
  
  useEffect(() => {
    const hashPart = location.hash;
    if (hashPart) {
      const element = document.getElementById(hashPart.slice(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  
  return null;
};

const App: React.FC = () => {
    return (
        <HelmetProvider>
            <CartProvider>
                <Router>
                    <div className="app-container">
                        <Navigation />
                        <ScrollToHashElement />
                        <div>
                            <Routes>
                                <Route path="/" element={
                                    <>
                                        <Helmet>
                                            <title>Perler med Vilje | Håndlagde perlesmykker med mening</title>
                                            <meta name="description" content="Håndlagde perlesmykker og armbånd laget med vilje. Unike armbånd, ørepynt og mobilpynt – 25% til Redd Barna." />
                                            <link rel="canonical" href="https://www.perlermedvilje.no/" />
                                            <meta property="og:type" content="website" />
                                            <meta property="og:site_name" content="Perler med Vilje" />
                                            <meta property="og:title" content="Perler med Vilje | Håndlagde perlesmykker med mening" />
                                            <meta property="og:description" content="Unike armbånd, ørepynt og mobilpynt. 25% av alt går til Redd Barna." />
                                            <meta property="og:url" content="https://www.perlermedvilje.no/" />
                                            <meta property="og:image" content="https://www.perlermedvilje.no/forside-banner_20x9.png" />
                                            <script type="application/ld+json">{JSON.stringify({
                                                '@context': 'https://schema.org',
                                                '@type': 'Store',
                                                name: 'Perler med Vilje',
                                                url: 'https://www.perlermedvilje.no/',
                                                image: 'https://www.perlermedvilje.no/logo_pvm.png',
                                                description: 'Håndlagde perlesmykker og armbånd – 25% til Redd Barna.',
                                                brand: { '@type': 'Brand', name: 'Perler med Vilje' }
                                            })}</script>
                                            <script type="application/ld+json">{JSON.stringify({
                                                '@context': 'https://schema.org',
                                                '@type': 'WebSite',
                                                name: 'Perler med Vilje',
                                                url: 'https://www.perlermedvilje.no/',
                                                potentialAction: {
                                                    '@type': 'SearchAction',
                                                    target: 'https://www.perlermedvilje.no/?s={search_term_string}',
                                                    'query-input': 'required name=search_term_string'
                                                }
                                            })}</script>
                                        </Helmet>
                                        <Hero />
                                        <div className="container">
                                            <div id="kategorier">
                                                <CategoryList />
                                            </div>

                                        </div>
                                        <HeroEnd />
                                        {/* <News /> */}
                                    </>
                                } />
                                <Route path="/category/:categorySlug" element={
                                    <div className="container">
                                        <ProductList />
                                    </div>
                                } />
                                <Route path="/product/:productId" element={<ProductDetail />} />
                                <Route path="/checkout" element={
                                    <>
                                        <Helmet>
                                            <title>Checkout | Perler med Vilje</title>
                                            <meta name="robots" content="noindex" />
                                            <meta name="description" content="Fullfør bestillingen din av håndlagde perlesmykker." />
                                            <link rel="canonical" href="https://www.perlermedvilje.no/checkout" />
                                        </Helmet>
                                        <Checkout />
                                    </>
                                } />
                                <Route path="/about" element={
                                    <>
                                        <Helmet>
                                            <title>Om oss | Perler med Vilje</title>
                                            <meta name="description" content="Historien bak Perler med Vilje – håndlagde smykker og støtte til Redd Barna." />
                                            <link rel="canonical" href="https://www.perlermedvilje.no/about" />
                                        </Helmet>
                                        <About />
                                    </>
                                } />
                                {/* <Route path="/news" element={
                                    <div className="container mt-4">
                                        <News />
                                    </div>
                                } /> */}
                            </Routes>
                            <Cart />
                        </div>
                        <Footer />
                    </div>
                </Router>
            </CartProvider>
        </HelmetProvider>
    );
};

export default App;